module.exports = __webpack_public_path__ + "img/buy_normal_id.c788bd33.png";